var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInformationIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.5C14.1333 2.5 17.5 5.86667 17.5 10C17.5 14.1333 14.1333 17.5 10 17.5C5.86667 17.5 2.5 14.1333 2.5 10C2.5 5.86667 5.86667 2.5 10 2.5ZM10 3.75C6.55 3.75 3.75 6.55 3.75 10C3.75 13.45 6.55 16.25 10 16.25C13.45 16.25 16.25 13.45 16.25 10C16.25 6.55 13.45 3.75 10 3.75ZM10.7334 13.5996H9.25879V8.08301L10.7334 8.0166V13.5996ZM10 6.22461C10.5583 6.22461 10.8164 6.43346 10.8164 6.8418C10.8163 7.25003 10.5666 7.4502 10 7.4502C9.44174 7.45019 9.17487 7.29168 9.1748 6.8418C9.1748 6.45013 9.44167 6.22461 10 6.22461Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInformationIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Information_Icon.3077a3c87e2879b1f43b30e9734d9326.svg";